export default __webpack_public_path__ + "static/media/web.14457e0c.png";